import { render, staticRenderFns } from "./TabHegu.vue?vue&type=template&id=1c65e285&scoped=true&"
import script from "./TabHegu.vue?vue&type=script&lang=js&"
export * from "./TabHegu.vue?vue&type=script&lang=js&"
import style0 from "./TabHegu.vue?vue&type=style&index=0&id=1c65e285&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c65e285",
  null
  
)

export default component.exports